import React from 'react'
import DownArrow from '../UI/DownArrow'

const Hero: React.FC = () => {
	const steamID = '3423700' // 3423700 on prod, 1841660 on stg
	const backgroundVideo = '/back_mute.webm' // Video from public folder
	const logoImage = '/hero_title.png'

	// Function to scroll to the next section
	const scrollToNextSection = () => {
		const nextSection = document.getElementById('features')
		if (nextSection) {
			nextSection.scrollIntoView({ behavior: 'smooth' })
		}
	}

	return (
		<div className="relative min-h-screen flex items-center justify-center overflow-hidden">
			{/* Background Video */}
			<video
				autoPlay
				loop
				muted
				playsInline
				className="absolute w-full h-full object-cover"
			>
				<source src={backgroundVideo} type="video/webm" />
			</video>

			{/* Overlay */}
			<div className="absolute inset-0 bg-black bg-opacity-50"></div>

			{/* Content */}
			<div className="relative z-10 text-center px-4">
				<img
					src={logoImage}
					alt="PLAN B4"
					className="w-auto max-w-full mx-auto mb-8 sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl"
				/>
				<p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-2xl mx-auto font-sans">
					The best and most modern 2D tactical shooter, inspired by Counter-Strike and Hotline Miami.
				</p>
				<div className="flex flex-col sm:flex-row gap-4 justify-center">
					<a
						href={`https://store.steampowered.com/app/${steamID}`}
						target="_blank"
						rel="noopener noreferrer"
						className="group relative inline-flex items-center px-8 py-4 border-2 border-green-500 text-lg font-bold rounded-md text-white bg-gradient-to-r from-green-600 via-green-500 to-green-600 font-sans overflow-hidden shadow-lg hover:shadow-green-500/50 transition-all duration-300"
					>
						{/* Animated background */}
						<div className="absolute inset-0 bg-gradient-to-r from-green-600 via-green-500 to-green-600 animate-gradient-x"></div>
						
						{/* Steam icon with animation */}
						<img 
							src="/steamlogo.png"
							alt="Steam"
							className="w-7 h-7 mr-3 transform animate-float" 
						/>
						
						{/* Text with animation */}
						<span className="relative transform animate-pulse-text">
							Wishlist on Steam
						</span>
					</a>
					<a
						href="https://discord.gg/7jDFHVJKV9"
						target="_blank"
						rel="noopener noreferrer"
						className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#5865F2] hover:bg-[#4752C4] transition-colors font-sans"
					>
						<svg className="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 24 24">
							<path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994.021-.041.001-.09-.041-.106a13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
						</svg>
						Join Discord
					</a>
				</div>
			</div>

			{/* Modern Scroll Down Arrow */}
			<div
				onClick={scrollToNextSection}
				className="absolute bottom-10 left-1/2 transform -translate-x-1/2 cursor-pointer animate-bounce sm:bottom-5 md:bottom-8 lg:bottom-10 z-20"
			>
				<DownArrow />
			</div>
		</div>
	)
}

export default Hero
